
class ToggleEmailText extends HTMLElement {
  constructor () {
    super()
    this.switch = document.querySelector('.frm-Switch')
    this.emailBody = document.querySelector('.sec-EmailBlock_Body')
    this.textBody = document.querySelector('.sec-TextBlock_Body')
  }

  connectedCallback () {
    this.init()
  }

  init () {
    if (this.switch) {
      this.switch.addEventListener('change', () => this.toggleSwitch())
    }
  }

  toggleSwitch () {
    this.emailBody.classList.toggle('sec-EmailBlock_Body-hide')
    this.textBody.classList.toggle('sec-TextBlock_Body-hide')

    const errorElement = document.querySelector('[data-signup-error]')
    const successElement = document.querySelector('[data-signup-success]')
    if (errorElement) {
      errorElement.classList.add('hidden')
    }
    if (successElement) {
      successElement.classList.add('hidden')
    }
    const forms = document.querySelectorAll('.sec-EmailBlock_Form')
    forms.forEach(form => {
      form.classList.remove('hidden')
    })
  }
}

if (!customElements.get('toggle-email-text')) {
  customElements.define('toggle-email-text', ToggleEmailText)
}
